module.exports = __webpack_public_path__ + "static/media/my_plans.ce7b2593.svg";